import React from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { ColorPicker } from "@common/colorPicker";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { ActivityWatcher } from "@common/activityWatcher";
import { TrashIcon } from "@common/trashIcon";
import { useTaskStatusEdition } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function Status({ status, deleteStatus, displayColorPickerCreation }: Props) {
  const { t } = useTranslation();
  const [nextStatus, setNextStatus] = React.useState(status);
  const { isRequestPending, editTaskStatus } = useTaskStatusEdition();
  const hasChanged = () =>
    nextStatus.color !== status.color ||
    nextStatus.label !== status.label ||
    nextStatus.percentComplete !== status.percentComplete;
  const isBasic = () => status.label.slice(0, "pr_".length) === "pr_";

  React.useEffect(() => {
    setNextStatus(status);
  }, [status]);

  return (
    <ActivityWatcher
      className={styles.status}
      blur={() =>
        !isRequestPending &&
        hasChanged() &&
        !isBasic() &&
        editTaskStatus({
          nextStatus,
          status,
        })
      }
    >
      <div>
        <div
          className={styles.color}
          style={{ backgroundColor: nextStatus.color }}
          onClick={(e) => {
            e.stopPropagation();
            !isBasic() &&
              displayColorPickerCreation(e.clientY, nextStatus, setNextStatus);
          }}
        />
        <div>
          <input
            className={classnames(styles.completion, {
              [styles.basicCompletion]: isBasic(),
            })}
            value={nextStatus.percentComplete}
            type="number"
            placeholder={"%"}
            onChange={({ target }) => {
              if (target.value === "") {
                setNextStatus({
                  ...nextStatus,
                  percentComplete: undefined,
                });
              } else if (
                parseInt(target.value) >= 0 &&
                parseInt(target.value) <= 100
              ) {
                setNextStatus({
                  ...nextStatus,
                  percentComplete: parseInt(target.value),
                });
              }
            }}
            readOnly={isBasic()}
          />
        </div>
        <input
          className={styles.label}
          value={
            isBasic()
              ? (t(`taskStatuses.${status.label}`, status.label) as string)
              : nextStatus.label
          }
          onChange={({ target }) =>
            setNextStatus({ ...nextStatus, label: target.value })
          }
          readOnly={isBasic()}
        />
      </div>
      {!isBasic() ? (
        <div onClick={deleteStatus} className={styles.trashBox}>
          <TrashIcon className={styles.icon} />
        </div>
      ) : (
        <div className={styles.trashBox} />
      )}
    </ActivityWatcher>
  );
}

export { Status };
